<app-logo-loader
  *ngIf="showLogoLoader || showCoverage"
  [delayLogoAnimation]="showCoverage"
  (animationFinished)="onLogoAnimationFinished()"
  [delayClose]="true"
  [close]="mainDataLoaded"
  [showLogo]="showLogoLoader"
></app-logo-loader>
<router-outlet></router-outlet>
<app-modal-container></app-modal-container>

<!-- HERE WILL RENDER MODALS USING ModalPortalService and <app-arkik-modal> -->
<ng-container *ngFor="let component of portal.components" [cdkPortalOutlet]="component"> </ng-container>
<ng-template #dynamicComponentContainer></ng-template>
